module.exports = __webpack_public_path__ + "fonts/TTNormsPro-MediumItalic.3297b45a.woff2";